import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { api, errMsg } from "../lib/api";

export default function Signup() {
  const [f, setF] = useState({ name: "", email: "", password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (f.password !== f.confirm) return setError("Les deux mots de passe ne correspondent pas");
    setBusy(true);
    try { await api.post("/auth/signup", { name: f.name, email: f.email, password: f.password }); setSent(true); } catch (err) { setError(errMsg(err)); }
    setBusy(false);
  };
  if (sent) {
    return (
      <div className="min-h-screen grid place-items-center p-6">
        <div className="tl-card max-w-md w-full text-center space-y-4" data-testid="signup-sent">
          <MailCheck className="mx-auto text-emerald-600" size={36} />
          <p className="text-sm">Si cette adresse peut être inscrite, un e-mail de confirmation vient d'être envoyé à <b>{f.email}</b>. Cliquez sur le lien pour remplir votre fiche d'inscription.</p>
          <Link to="/login" className="tl-btn tl-btn-primary w-full" data-testid="signup-back">Retour à la connexion</Link>
        </div>
      </div>
    );
  }
  return (
    <div className="min-h-screen grid place-items-center p-4 sm:p-6">
      <form onSubmit={submit} className="tl-card max-w-md w-full space-y-4" data-testid="signup-form">
        <div>
          <h2 className="text-2xl font-bold uppercase">Créer un compte</h2>
          <p className="text-sm text-slate-500 mt-1">Après confirmation de votre e-mail, vous remplissez votre fiche. L'accès et le rôle sont attribués par l'administrateur ou un gestionnaire.</p>
        </div>
        {[["name", "Nom complet", "text"], ["email", "E-mail", "email"], ["password", "Mot de passe (8 caractères min.)", "password"], ["confirm", "Confirmer le mot de passe", "password"]].map(([k, l, type]) => (
          <label key={k} className="block">
            <span className="tl-label">{l}</span>
            <input className="tl-input" type={type} required minLength={k.includes("pass") || k === "confirm" ? 8 : undefined} value={f[k]} onChange={set(k)} autoComplete={type === "password" ? "new-password" : k} data-testid={`signup-${k}`} />
          </label>
        ))}
        {error && <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg p-3" data-testid="signup-error">{error}</div>}
        <button className="tl-btn tl-btn-primary w-full" disabled={busy} data-testid="signup-submit">{busy && <Loader2 className="animate-spin" size={16} />} Recevoir le lien de confirmation</button>
        <Link to="/login" className="text-sm underline block text-center" data-testid="signup-login-link">J'ai déjà un compte</Link>
      </form>
    </div>
  );
}
